import React from 'react';

const defaultCartState = {
    products: [],
    updateProducts: () => [],
}

const CartContext = React.createContext(defaultCartState);

export default CartContext;